import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useToaster } from '@components/toaster';

import { api } from 'api';
import { useStore } from 'models/Provider';

type Props = {
  applicationId: number;
};

export function useUnHireApplication() {
  const { applicationStore, t } = useStore();
  const { showError, showSuccess } = useToaster();

  const queryClient = useQueryClient();

  return useMutation((props: Props) => api.applications.unHire(props.applicationId), {
    onSuccess: (_, { applicationId }) => {
      showSuccess(t('application.unhire.success'));
      setTimeout(() => queryClient.invalidateQueries(['applicants']), 2000);
      applicationStore.unHire(applicationId);
    },
    onError: () => {
      showError(t('application.unhire.error'));
    },
  });
}
